import Slideshow from './Onboarding';

export const onboardingRoute = {path: '/', name: 'Slideshow', Component: Slideshow, exact: false};
